import {z} from '@hono/zod-openapi';

import {VoiceDebugSpendProjectionSchema} from './VoiceDebugSpendProjectionSchema';
import {VoiceDebugTerminalOutcomeSchema} from './VoiceDebugTerminalOutcomeSchema';

export const VoiceDebugCallStateResponseSchema = z
  .object({
    schemaVersion: z.literal('1.0.0'),
    sessionId: z.string().uuid(),
    voiceConversationId: z.string().min(1).max(128).regex(/\S/),
    state: z.enum(['connecting', 'active', 'ending', 'ended', 'failed']),
    scenarioId: z.string().min(1).max(128),
    scenarioVersion: z.string().min(1).max(64),
    phase: z.string().min(1).max(128).nullable(),
    currentQuestion: z.string().max(4096).nullable(),
    agentTranscript: z.string().max(16_384).nullable(),
    callerTranscriptAvailable: z.boolean(),
    terminalOutcome: VoiceDebugTerminalOutcomeSchema.nullable(),
    spend: VoiceDebugSpendProjectionSchema,
    lastSequence: z.number().int().nonnegative(),
    expiresAt: z.string().datetime({offset: true}),
  })
  .strict()
  .openapi('VoiceDebugCallStateResponseSchema');

export type VoiceDebugCallStateResponse = z.infer<typeof VoiceDebugCallStateResponseSchema>;
